/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import SharedOwnerNotification from './components/SharedOwnerNotification';
import SurveyReminderNotification from './components/SurveyReminderNotification';
import PendingDataNotification from './components/PendingDataNotification';

import AppNavTopLevel from '../../../components/appNav/AppNavTopLevel';
import {
  actions as notificationActions,
  selectors as notificationsSelector,
} from '../../../redux/ducks/notifications';
import { RelativeDate } from '../../../localization/LocalizedDate';
import ContentLoader from '../../../components/ContentLoader';
import RandomizedTips from '../../../components/RandomizedTips';

import './Notifications.styles.scss';
import { EmptyCard } from '../../../components/card/Card';
import ContentWrapper from '../../../components/ContentWrapper';
import DateUtil from '../../../../utilities/DateUtil';

function mapStateToProps(state) {
  return {
    notifications: notificationsSelector.getAll(state),
    isLoaded: notificationsSelector.isLoaded(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadInitialData: () => {
      dispatch(notificationActions.requestAll());
    },
  };
}

class Notifications extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.loadInitialData();
  }

  groupByDate(notifications) {
    const sorted = notifications.sort((a, b) => {
      return DateUtil.compareDatesDescending(a.created_at, b.created_at);
    });

    const grouped = _.groupBy(sorted, n =>
      moment(n.created_at).format('YYYYMMDD')
    );

    return _.sortBy(grouped, (g, i) => i).reverse();
  }

  renderNotification(notification) {
    switch (notification.type) {
      case 'survey_reminder':
        return <SurveyReminderNotification key={notification.id} notification={notification} />;
      case 'shared_owner':
        return <SharedOwnerNotification key={notification.id} notification={notification} />;
      case 'pending_data':
        return <PendingDataNotification key={notification.id} notification={notification} />
      default:
        return null;
    }
  }

  renderGroup(collection) {
    const grouped = collection
      .map((notifications, index) => {
        const groupDate = _.get(notifications, '[0].created_at');
        return (
          <div key={index}>
            <EmptyCard className="cmp-notification-date">
              <RelativeDate date={groupDate} precision="P1D" dateKind="medium" />
            </EmptyCard>

            {notifications.length > 0 ? notifications.map(n => this.renderNotification(n)) : null}
          </div>
        );
      });

    return grouped.length > 0 ? (
      grouped
    ) : (
      <div className="cmp-notifications-zerostate font-subhead font-color-gsMiddle">
        <FormattedMessage id="notifications.noNotifications.message.text" />
      </div>
    );
  }

  render() {
    const relevantNotifications = this.props.notifications;//.filter(c => c.isRelevantToApplication);
    const groupByDate = this.groupByDate(relevantNotifications);
    const titleId = 'notifications.title.text';

    return (
      <div>
        <ScrollAwareContext>
          <AppNavTopLevel hasDropShadow />

          <ContentFrame className="bkgd-color-csAppBGgray">
            <ContentLoader isContentLoaded={this.props.isLoaded} blockRenderUntilLoaded isFixed>
              <ScrollAwareScroller>
                <AppHeaderScrollableText id={titleId} />
                <ContentWrapper>
                  <div className="cmp-notifications">
                    {this.renderGroup(groupByDate)}
                    <RandomizedTips
                      headingId="notification.tip.heading"
                      className="cmp-notifications-tips util-application-frame-forcards-padding"
                      linkClassName="cmp-notifications-tips-link"
                      baseTipId="notification.tip.tip"
                      countId="notification.tip.count"
                    />
                  </div>
                </ContentWrapper>
              </ScrollAwareScroller>
            </ContentLoader>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
Notifications.propTypes = {
  notifications: PropTypes.array,
  goBack: PropTypes.func,
  loadInitialData: PropTypes.func,
  isLoaded: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
